const WinlosesTypes = {
    FETCH_START:    '[MANAGERS][WINLOSES] FETCH START',
    FETCH_SUCCESS:  '[MANAGERS][WINLOSES] FETCH SUCCESS',
    FETCH_FAILURE:  '[MANAGERS][WINLOSES] FETCH FAILURE'
};

export default WinlosesTypes;